<template>
    <div class="login">
        <b-container>
            <b-row class="full-height">
                <div class="form-login align-self-center">
                    <img class="img-fluid logo" src="../../assets/imgs/domik_dark_logo.svg" alt="">
                    <p class="mb-5 mt-3">Bienvenido al registro de Domik Medical Apparel</p>
                    <b-form>
                        <b-form-group id="input-group-1" class="mb-4 cont form-floating">
                            <div v-if="error" :key="error" class="alert">
                                Usuario y/o contraseña incorrectos, revisa los datos ingresados y vuelve a intentar
                            </div>
                            <div class="form-floating">
                                <b-form-input
                                    id="input-1"
                                    v-model="user"
                                    type="text"
                                    placeholder="Usuario"
                                    required
                                    @keyup.enter="submitLogin"
                                    ></b-form-input>
                                <label for="">Usuario</label>
                                <img class="icon" src="../../assets/imgs/icn_user.svg" alt="">
                            </div>
                        </b-form-group>

                        <b-form-group id="input-group-2" class="mb-5 cont">
                            <div class="form-floating">
                                <b-form-input
                                    id="input-2"
                                    v-model="password"
                                    placeholder="Contraseña"
                                    type="password"
                                    required
                                    @keyup.enter="submitLogin"
                                    ></b-form-input>
                                <label for="">Contraseña</label>
                                <img class="icon" src="../../assets/imgs/icn_password.svg" alt="">
                            </div>
                        </b-form-group>
                        <b-button v-on:click="submitLogin" v-on:keyup.enter="submitLogin">Iniciar sesión para registrar mis datos</b-button>
                    </b-form>
                    <div class="wrapper-social-media">
                        <a href="https://www.facebook.com/uniformesmedicosdomik?mibextid=ZbWKwL" target="_blank"><img class="" src="../../assets/imgs/icn_facebook.svg" alt=""></a>
                        <a href="https://instagram.com/domikuniformes?igshid=YmMyMTA2M2Y=" target="_blank"><img class="" src="../../assets/imgs/icn_instagram.svg" alt=""></a>
                        <a href="https://www.linkedin.com/company/domik-medical-apparel/" target="_blank"><img class="" src="../../assets/imgs/icn_linkedin.svg" alt=""></a>
                        <a href="https://domikuniformes.com/" target="_blank"><img class="" src="../../assets/imgs/icn_website.svg" alt=""></a>
                    </div>

                </div>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
    export default {
        data() {
            return {
                user: '',
                password: '',
                error: false
            }
        }, 
        created(){
            sessionStorage.removeItem('dataUser')
        },
        methods: {
            submitLogin(){
                this.error = false
                axios
                .post(
                    process.env.VUE_APP_ROUTE_BACKEND_API+'login.php',
                    qs.stringify({ user: this.user, pass: this.password }),
                )
                .then((response) => {
                    if (!response.data.error.code && response.data.api_token) {
                        sessionStorage.setItem('api_token', response.data.api_token)
                        sessionStorage.setItem('id_user', response.data.user.id)
                        sessionStorage.setItem('is_admin', response.data.user.is_admin)
                        sessionStorage.setItem('hospital_user', JSON.stringify(response.data.hospital))
                        if(response.data.models){
                            sessionStorage.setItem('models_user', JSON.stringify(response.data.models))
                        }
                        if(response.data.collaborators){
                            sessionStorage.setItem('collaborators_user', JSON.stringify(response.data.collaborators))
                        }
                        this.$router.push('/orden')
                    } else {
                        this.error = true
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style scoped>
.login{
    text-align: center;
    min-height: 100vh;
    background-color: #FCFCFC;
}
.alert{
    background: #FDEDEE;
    padding: 10px 20px;
    border-radius: 10px;
    width: 100%;
    font-weight: 600;
}
p{
    font-size: 22px;
}
.full-height{
    min-height: 100vh;
    height: 100%;
}
.form-login{
    max-width: 675px;
    margin-left: auto;
    margin-right: auto;
}
.cont{
    position: relative;
}
.icon{
    position: absolute;
    bottom: 20px;
    left: 25px;
}
.btn{
    background: #F15E1A;
    border: none;
    width: 100%;
    border-radius: 10px;
    font-size: 20px;
    padding: 16px 20px;
}
.btn:focus,
.btn:hover{
    background: #F15E1A;
    border: none;
}
.form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-select ~ label{
    padding-left: 3.5rem !important;
}
.form-control{
    border: 1px solid rgba(17, 35, 87, 0.5) !important;
    border-radius: 5px;
    color: #112357 !important;
    font-size: 20px !important;
    padding:  0.5rem 2.5rem 0rem 3rem !important;
    background: transparent !important;
}
.form-floating > label {
    padding: 0.8rem 2.9rem !important;
    color: #112357;
    opacity: 1;
    font-size: 20px;
}
.form-control:focus,
.form-control:hover,
.form-control:active{
    border: 1px solid rgba(17, 35, 87, 0.5) !important;
}
.wrapper-social-media{
    margin-top: 70px;
}
.wrapper-social-media a{
    margin: 12px;
}
@media (max-width: 1600px) {
    .wrapper-social-media{
        margin-top: 50px;
    }
    .wrapper-social-media a{
        margin: 10px;
    }
    .wrapper-social-media img{
        width: 40px;
    }
    .form-login{
        max-width: 480px;
    }
    .logo{
        width: 75%;
    }
    p{
        font-size: 14px; 
    }
    .btn{
        font-size: 14px;
        padding: 10px 20px;
        border-radius: 7px;
    }
    .form-control{
        font-size: 14px !important;
        padding: 5px 0.75rem;
        padding-top: 0.5rem !important;
    }
    .form-floating > label {
        padding: 0.6rem 2.9rem !important;
        font-size: 15px ;
    }
    .icon{
        position: absolute;
        bottom: 17px;
        left: 25px;
        height: 13px;
    }
    .footer img{
        height: 55px;
    }
    .form-floating > .form-control{
        height: calc(3rem + 2px) !important;
    }
    .form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-select ~ label{
        opacity: 1 !important;
        font-size: 12px;
        padding: 1rem 3.5rem !important;
    }
}
</style>